export default "__VITE_ASSET__BuQAwgFb__"